// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a1","header":"a2","container":"a3","greenLink":"a4"};